import { useMemo } from 'react';

import type { AIWatermarkColor } from '~/amplienceTypes/partials/exported/responsive-image-schema';
import { useStaticContext } from '~/utilities/context/static/StaticContext';
import type { ImageLinkLike, ShouldShowAiIconParams } from '~/utilities/helpers/shouldShowAiIcon';

const AI_ALT_MARKER_PATTERN = /\[ai\]/gi;

export type ResponsiveImageLike = {
  alt?: string;
  mobile?: ImageLinkLike;
  tablet?: ImageLinkLike;
  desktop?: ImageLinkLike;
  images?: {
    mobile?: ImageLinkLike;
    tablet?: ImageLinkLike;
    desktop?: ImageLinkLike;
  };
  aiWatermarkColor?: AIWatermarkColor;
};

export const mapResponsiveImageAiIconParams = (
  image?: ResponsiveImageLike
): ShouldShowAiIconParams => ({
  alt: image?.alt,
  imageLinks: [
    image?.mobile,
    image?.tablet,
    image?.desktop,
    image?.images?.mobile,
    image?.images?.tablet,
    image?.images?.desktop,
  ],
  aiWatermarkColor: image?.aiWatermarkColor,
});

export const useAiWatermarkParams = (image?: ResponsiveImageLike) => {
  const {
    configuration: { aiImageWatermarkLabel, aiImagesWatermarkEnabled },
  } = useStaticContext();

  return useMemo(() => {
    const placeholderText = aiImagesWatermarkEnabled ? aiImageWatermarkLabel || '' : '';

    return {
      params: mapResponsiveImageAiIconParams(image),
      imageAltText: image?.alt?.replace(AI_ALT_MARKER_PATTERN, placeholderText)?.trim(),
    };
  }, [aiImageWatermarkLabel, aiImagesWatermarkEnabled, image]);
};
